import { Button, Container, FormHelperText, Grid, Typography } from '@mui/material';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import RtlProvider from '../../../Components/RtlProvider';
import helper from '../../../helper';
import hotelApi from '../../../api/hotelApi';
import cityApi from '../../../api/cityApi';
import planAttachmentApi from '../../../api/planAttachmentApi';
import { ContextNotification, severitys } from '../../../App';
import staticVariablesApi from '../../../api/staticVariablesApi';
import BeatLoading from '../../../Components/Loader/BeatLoader';

const AddPlanAttachment = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const schema = yup.object().shape({
    CityConsistency: yup.string().required("شهر را انتخاب نمایید"),
    hotelId: yup.string().required("هتل را انتخاب نمایید"),
    ImageFile: yup.mixed()
      .test("required", "فایل را انتخاب نمایید", value => value?.length > 0)
      .test("fileType", "فرمت های مجاز pdf,jpeg,jpg,png", (files) => {
        let valid = true
        for (let index = 0; index < files?.length; index++) {
          const element = files[index];
          if (element.type !== "image/jpeg" && element.type !== "image/png" && element.type !== "image/jpg" && element.type !== "application/pdf") {
            valid = false;
          }
        }
        return valid;
      })
  });

  const { register, handleSubmit, formState: { errors }, control, resetField } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    setSubmitLoading(true);
    const formData = new FormData();
    formData.append("HotelID", data.hotelId);
    for (let index = 0; index < data.ImageFile.length; index++) {
      const element = data.ImageFile[index];
      formData.append("ImageFile", element)
    }
    planAttachmentApi.Add(formData)
      .then((res) => {
        if (res.data.success) {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
          resetForm();
        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
        }
      }).catch(err => {
        if (err.response) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
      }
      ).finally(() => { setSubmitLoading(false); });
  };
  useEffect(() => {
    GetCityDropDown();
  }, []);
  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    setHotels(null);
    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const handleHotelChanged = useCallback(async (id) => {
    // resetField("");
    if (id) {
      const planAttachments = await fetchPlanAttachmentsByHotelId(id);
      const hotelFiles = planAttachments?.hotelFiles;

      hotelFiles.map((item) => {
        return {
          base64File: 'data:' + item.contentType + ";base64," + item.base64File,
          fileName: item.fileName,
          contentType: item.contentType
        };
      })
    }
  }, []);

  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };

  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };

  const fetchPlanAttachmentsByHotelId = async (hotelId) => {
    try {
      let res = await planAttachmentApi.GetHotelAttachments(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };

  const resetForm = () => {
    resetField("CityConsistency");
    resetField("hotelId");
    resetField("ImageFile");
  }
  return (
    <Container component="main" maxWidth="xs">
      <form onSubmit={handleSubmit(onSubmit)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            افزودن پلان مهندسی
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <RHFAutocomplete
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                disabled={Cities === null}
                error={!!errors?.CityConsistency}
                helperText={errors?.CityConsistency?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RHFAutocomplete
                control={control}
                options={Hotels ?? []}
                name="hotelId"
                placeholder="هتل"
                onChange={handleHotelChanged}
                disabled={Cities === null}
                error={!!errors?.hotelId}
                helperText={errors?.hotelId?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <input type="file" multiple {...register("ImageFile")} accept='image/*,application/pdf' />
              <FormHelperText error={!!errors?.ImageFile}>{errors.ImageFile?.message}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />افزودن</Button>
            </Grid>
          </Grid>
        </RtlProvider>
      </form>
    </Container>
  )
}

export default AddPlanAttachment